import updateLoanSectionData from "components/Loans/LoanStepper/components/lib/updateLoanSectionData";
import insertFirebaseUploader from "components/listings/Uploader/utils/insertFirebaseUploader";

async function updateLoanSectionController2(
  loan,
  setLoanSectionController,
  loanSectionController,
  user,
  stepID
) {
  if (!insertFirebaseUploader(loan)) {
    setLoanSectionController(loanSectionController);
  } else {
    setLoanSectionController(loanSectionController);

    // update SD_

    const updatedSection = loanSectionController[stepID];

    (async () => {
      const updatedLoan = await updateLoanSectionData(
        user,
        loan,
        stepID,
        updatedSection
      );
    })();
  }
  // NEW
  // DIFF the difference in updated LSC
  // vs prevLSC?
  // no diff in this because we know whats being updated
  // stepID
  // OLD
  // for security reasons to compare those value on backend
  // // all the query params need to be provided
  // const targetUrl = `${process.env.CMS_URL}/loans/${currentLoan.id}`;
  // const token = await user.getIdToken();
  // // dataTranslation
  // const res = await fetch(targetUrl, {
  //   method: "PUT",
  //   headers: {
  //     "Content-Type": "application/json",
  //     Authorization: `Bearer ${token}`,
  //   },
  //   body: JSON.stringify({
  //     LoanSectionController: loanSectionController,
  //   }),
  // });
  // const respJSON = await res.json();
  // if (setCurrentLoan) {
  //   setCurrentLoan(respJSON);
  // }
  // return respJSON;
}

export default updateLoanSectionController2;
